import { make } from 'vuex-pathify'
import store from '../index'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import { formatDate } from '@/util/formatters'
import axios from 'axios'

const state = {
  goal: {
    users: [],
  },
  goals: {
    data: [],
    count: 0,
    limit: 50,
  },

  filter: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ['name'],
    sortDesc: [false],
  },

  type: 'add',
  loading: false,
  dialog: false,
  dialogUserDetails: false,
}

const mutations = make.mutations(state)

const actions = {
  add: ({ state }) => {
    state.goal = {
      users: [],
      status: 'Em Andamento',
      companyId: store.get('authStore@currentCompany').id,
    }
    state.type = 'add'
    state.dialog = true

    store.dispatch('goalStore/loadCombos')
  },

  edit: ({ state }, id) => {
    state.loading = true
    store.dispatch('goalStore/getById', id)
      .then(res => {
        state.goal = res.data

        state.type = 'edit'
        state.dialog = true

        // format data
        state.goal.startDate = res.data.startDate
          ? formatDate(new Date(res.data.startDate).toISOString().substr(0, 10))
          : null
        state.goal.date = formatDate(new Date(res.data.date).toISOString().substr(0, 10))

        store.dispatch('goalStore/loadCombos')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  loadCombos: async () => {
    store.dispatch('userStore/get', {
      page: 1,
      itemsPerPage: 10000,
      type: 1,
      sortBy: ['name'],
      sortDesc: ['desc'],
    })
  },

  save: ({ state }, goal) => {
    const id = goal.id
    const method = id ? 'put' : 'post'

    state.loading = true
    return axios[method](`${process.env.VUE_APP_API_URL}/goal/${id || ''}`, goal)
      .then((res) => {
        state.dialog = false
        store.dispatch('goalStore/get')
        showSuccess('Meta salva com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  get: async ({ state }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/goal?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.goals = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getById: (context, id) => axios.get(`${process.env.VUE_APP_API_URL}/goal/${id}`).catch(showError),

  remove: ({ state }, id) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/goal/${id}`)
      .then(_ => {
        store.dispatch('goalStore/get')

        showSuccess('Meta excluída com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
